import {
  TextResource, LanguageListResource, ApplicationResource, LaserResultResource, ResultEmailResource,
} from './resources';

export default {
  getDbLanguageList() {
    return LanguageListResource.get();
  },
  getDbText(payload) {
    return TextResource.get({ lang: payload });
  },
  getApplications({ lang, type, cat }) {
    return ApplicationResource.get({ lang, type, cat });
  },
  getLaserResult(payload) {
    return LaserResultResource.save(payload);
  },
  sendResultEmail(payload) {
    return ResultEmailResource.save(payload);
  },
};



// WEBPACK FOOTER //
// ./src/api/index.js